import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Заявка на консультацию отправлена',
  description: 'Мы перезвоним вам в течение часа рабочего дня',
} satisfies TMessages
